import { render, staticRenderFns } from "./AdminNavigationDrawer.vue?vue&type=template&id=8165a062&"
import script from "./AdminNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./AdminNavigationDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports